import { createPrefixer } from '@mews-commander/utils';

export const MODULE_NAME = 'trackingConsent';
export const prefix = createPrefixer(MODULE_NAME);
